import React, { useState, useEffect, useCallback } from 'react';
import NoticeItem from './NoticeItem';
import { fetchGlobalNotices, fetchDepartmentNotices } from '../api';
import './NoticeList.css'; // Placeholder

const NoticeList = ({ title, type, college, department, refreshTrigger }) => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadNotices = useCallback(async () => {
    let currentCode = null;

    if (type === 'college' && college) {
        currentCode = college.code;
    } else if (type === 'department' && department) {
        currentCode = department.code;
    }

    if (type !== 'global' && !currentCode) {
        setNotices([]);
        return;
    }

    setLoading(true);
    setError(null);
    try {
      let data = [];
      if (type === 'global') {
        data = await fetchGlobalNotices();
      } else {
        data = await fetchDepartmentNotices(currentCode);
      }
      setNotices(data);
    } catch (err) {
      setError('공지사항을 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  }, [type, college, department]);

  useEffect(() => {
    loadNotices();
  }, [loadNotices, refreshTrigger]);

  return (
    <div className="notice-list-container">
      <div className="notice-list-header">
        <h2>{title}</h2>
      </div>
      
      <div className="notice-list-content">
        {loading && <div className="loading">로딩 중...</div>}
        {error && <div className="error">{error}</div>}
        {!loading && !error && notices.length === 0 && (
          <div className="empty">공지사항이 없습니다.</div>
        )}
        {!loading && !error && notices.map((notice, index) => (
          <NoticeItem key={`${notice.url}-${index}`} notice={notice} />
        ))}
      </div>
    </div>
  );
};

export default NoticeList;
